import React from "react";

import classes from "./Space.module.css";
//this component adds empty space between components
//determine the height in props.height
const Space = (props) => {
  return (
    <div className={classes.container} style={{ height: props.height }}></div>
  );
};
export default Space;
